/**
 * ThreadHeading - Thread subject heading with back navigation
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';

function ThreadHeading({ messageDetails, handleMarkAsUnRead, isFromClientPortal }) {
  const history = useHistory();

  return (
    <div className="d-flex mb-1 align-items-center" role="region" aria-label="Thread header">
      <a
        href={`/#/cases/${messageDetails?.case?.case_id || ''}/messages`}
        onClick={(e) => {
          e.preventDefault();
          history.goBack();
        }}
        className="text-decoration-none"
        aria-label="Go back to message list"
      >
        <i className="icon-back icon-box me-3 pointer" aria-hidden="true" />
      </a>

      <div className="d-flex w-100 align-items-center">
        <h1 className="title gray-800 mb-0 fs-3 fs-md-1 ml-1">Thread: {messageDetails?.subject || 'Untitled Thread'}</h1>
        {messageDetails?.is_new && (
          <span style={{ marginLeft: '0.5rem' }}>
            <Tag className="p-mr-2 tag-case" value="New" rounded aria-label="New message thread" />
          </span>
        )}
      </div>

      {isFromClientPortal && (
        <div className="d-flex w-100 justify-content-end">
          <Button
            label="Mark as Unread"
            className="btn-outline p-button-secondary outline py-1 px-3 me-2"
            type="button"
            style={{ overflow: 'inherit' }}
            onClick={(e) => handleMarkAsUnRead(e, messageDetails, true)}
            aria-label="Mark this thread as unread"
          />
        </div>
      )}
    </div>
  );
}

ThreadHeading.propTypes = {
  messageDetails: PropTypes.shape({
    subject: PropTypes.string,
    is_new: PropTypes.bool,
    case: PropTypes.shape({
      case_id: PropTypes.string,
    }),
  }),
  handleMarkAsUnRead: PropTypes.func,
  isFromClientPortal: PropTypes.bool,
};

ThreadHeading.defaultProps = {
  messageDetails: null,
  handleMarkAsUnRead: () => {},
  isFromClientPortal: false,
};

export default memo(ThreadHeading);
